export default function importHttp (tagName = 'script', options = { }, target) {
  if (document) {
    let tag = document.createElement(tagName)
    let id = hashCode(JSON.stringify(options))
    if (id === tag.id) {
    } else {
      target = target || document.head
      tag.id = id
      Object.keys(options).forEach(key => {
        if (key !== 'events') {
          tag.setAttribute(key, options[key])
        }
      })
      // console.log(options)
      options.events && options.events.forEach(item => {
        tag.addEventListener(item.name, item.handler)
      })
      target.appendChild(tag)
    }
  } else {
    this.$message({
      message: `请用浏览器访问`,
      type: `error`
    })
  }
}
export function hashCode (str) {
  var h = 0
  var len = str.length
  var t = 2147483648
  for (var i = 0; i < len; i++) {
    h = 31 * h + str.charCodeAt(i)
    if (h > 2147483647) h %= t // java int溢出则取模
  }
  console.log(h)
  /* var t = -2147483648 * 2;
     while (h > 2147483647) {
     h += t
     } */
  return h
}
